import React, { type PropsWithChildren } from 'react';
import { Grid, type GridProps } from '@atlaskit/primitives';
import ThreadLine from './thread-line.tsx';

type Props = {
	showThreadLines?: boolean;
};

const defaultTemplateAreas = ['header header', '. body', '. footer'];

const parentTemplateAreas = ['header header', 'thread-line body', 'thread-line footer'];

const Comment = ({
	children,
	templateAreas: templateAreasProp,
	templateRows = '1fr',
	templateColumns = '36px 1fr',
	gap,
	columnGap = 'space.100',
	rowGap = 'space.150',
	testId,
	showThreadLines,
}: PropsWithChildren<Props & GridProps>) => {
	const templateAreas = showThreadLines ? parentTemplateAreas : defaultTemplateAreas;
	return (
		<Grid
			templateAreas={templateAreasProp || templateAreas}
			templateRows={templateRows}
			templateColumns={templateColumns}
			gap={gap}
			columnGap={columnGap}
			rowGap={rowGap}
			testId={testId}
		>
			{children}
			{showThreadLines && <ThreadLine />}
		</Grid>
	);
};

export default Comment;
